var _rect, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRetailBg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 350,
    height: 241,
    viewBox: "0 0 350 241",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10427_6750",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 350,
    height: 241
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 350,
    height: 241,
    fill: "#EEF8FF"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10427_6750)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_10427_6750",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -1,
    width: 352,
    height: 324
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 351.08,
    height: 322.163,
    transform: "matrix(-1 0 0 1 351.08 -0.00598145)",
    fill: "#E9F7EF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_10427_6750)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.2,
    cx: 111.612,
    cy: 111.037,
    rx: 111.612,
    ry: 111.037,
    transform: "matrix(-1 0 0 1 167.68 174.109)",
    fill: "#EB0117"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M263.046 -10.4732C259.787 -10.1091 256.805 -8.47203 254.756 -5.91773C252.707 -3.36292 251.759 -0.0995528 252.127 3.15471L260.374 76.1933C260.741 79.4476 262.393 82.4205 264.961 84.4593C267.528 86.4977 270.802 87.4357 274.06 87.0716L329.123 80.9182C332.381 80.5541 335.363 78.917 337.412 76.3627C339.462 73.8079 340.409 70.5445 340.042 67.2903L333.857 12.5138L333.599 10.2288C333.505 9.39806 333.084 8.63853 332.428 8.11824L304.356 -14.1685C303.705 -14.6857 302.875 -14.9243 302.049 -14.8319L263.046 -10.4732ZM327.958 16.3356L333.791 67.9888C333.97 69.5773 333.508 71.1744 332.502 72.4286C331.496 73.6834 330.027 74.4918 328.417 74.6716L273.355 80.825C271.745 81.0049 270.132 80.5409 268.871 79.5396C267.61 78.5387 266.804 77.0833 266.625 75.4948L258.378 2.45617C258.198 0.867669 258.66 -0.729483 259.666 -1.98368C260.673 -3.23839 262.142 -4.0468 263.751 -4.22667L297.334 -7.97965L300.074 16.289C300.269 18.0139 301.826 19.2559 303.552 19.063L327.958 16.3356ZM303.823 -6.56763L305.972 12.4672L325.106 10.329L303.823 -6.56763Z",
    fill: "#FFBBBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.956 37.7363L278.247 41.8386",
    stroke: "#FFBBBF",
    strokeWidth: 6.288,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.018 55.9903L280.31 60.0926",
    stroke: "#FFBBBF",
    strokeWidth: 6.288,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.361 22.5508L276.184 23.5764",
    stroke: "#FFBBBF",
    strokeWidth: 6.288,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetailBg);
export default __webpack_public_path__ + "static/media/RetailBg.4930f91ae043174ff77805a90ecb550d.svg";
export { ForwardRef as ReactComponent };